import { Injectable, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { CfgEndpoint } from './cfgEndpoint';
import { LoginResponseDTO } from '../DTO';

Injectable()
export class CfgService {
  public cfg: CfgEndpoint[];
  private PERSIST_KEY = "pidoor-service-cfg";

  constructor(@Inject(Http) private http: Http) {
    this.cfgLoad();
  }

  public cfgPersist = (): void => {
    const str = JSON.stringify(this.cfg);
    window.localStorage.setItem(this.PERSIST_KEY, str);
  }
  public cfgLoad = (): void => {
    let list: CfgEndpoint[] = [];

    try {
      let str = window.localStorage.getItem(this.PERSIST_KEY);
      if (str) {
        list = JSON.parse(str);
      }
    }
    catch (error) {
      console.error(`Failed getItem cfg, ${error}`);
    }
    this.cfg = list;
  }
  public cfgClear = (): void => {
    this.cfg = [];
    this.cfgPersist();
  }
  public cfgTest = (cfg: CfgEndpoint): Promise<void> => {
    return new Promise<void> ((resolve, reject) => {
      const headers = new Headers();
      headers.append("Content-Type", "application/x-www-form-urlencoded");
      const body=`username=${encodeURIComponent(cfg.Uname)}&password=${encodeURIComponent(cfg.Pwd)}&grant_type=password`;

      this.http.request(`${cfg.Url}/login`, {headers: headers, method: "POST", body: body})
      .toPromise().then (response => {
        const dto = response.json() as LoginResponseDTO;
        cfg.access_token = dto.access_token;
        cfg.token_type = dto.token_type;
        resolve();
      }, error => {
        reject(error);
      }).catch((ex) => {
        reject(ex);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/door/cfgService.ts